export const COOKIE_ID_SEPARATOR = "~";
export const LOCALE_DEFAULT = "en";
